var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack227({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.12,11.43a5.59,5.59,0,0,0,1.39.73l-.64,1.22a3.4,3.4,0,0,1-.77-.32s-.44-.28-1.15-.76a4.56,4.56,0,0,1-1.87.37A4.08,4.08,0,0,1,5,11.5,4.51,4.51,0,0,1,3.85,8.23,4.54,4.54,0,0,1,5,5,4.07,4.07,0,0,1,8,3.79a4,4,0,0,1,3,1.16,4.53,4.53,0,0,1,1.12,3.28,5.54,5.54,0,0,1-.31,1.95A4.2,4.2,0,0,1,11.12,11.43Zm-1.39-1a2.53,2.53,0,0,0,.5-.95,4.45,4.45,0,0,0,.16-1.27A3.3,3.3,0,0,0,9.74,6,2.19,2.19,0,0,0,8,5.27,2.17,2.17,0,0,0,6.3,6a3.24,3.24,0,0,0-.66,2.22,3.32,3.32,0,0,0,.66,2.25A2.13,2.13,0,0,0,8,11.23a1.9,1.9,0,0,0,.71-.13,5,5,0,0,0-1.08-.54l.49-1A6.08,6.08,0,0,1,9.73,10.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack227);
export default __webpack_public_path__ + "static/media/Symbolpack_2_27.3a658c8f4d405014b86ccfb67275ce9f.svg";
export { ForwardRef as ReactComponent };